<template>
  <div id="risk-test">
    <div v-if="login_type === 'person'">
      <div class="desc"></div>

      <v-form ref="form" v-model="valid">
        <div class="section1">
          <div class="question">
            <span class="num">1</span>
            <span class="title">作为私募投资基金的投资者，您符合下列哪些标准（可选多项）</span>
          </div>
          <div v-for="(item, index) in test1_question" :key="index">
            <v-checkbox class="checkbox-answer" v-model="temp.test1" :value="index + 1" :label="item" :rules="[() => rules.atLeastOneSkill(temp.test1)]" color="orange" :hide-details="index !== (test1_question.length - 1)"></v-checkbox>
          </div>

          <div class="question">
            <span class="num">2</span>
            <span class="title">您的主要收入来源是</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test2" :rules="testRules" column>
            <v-radio label="A、工资、劳务报酬" color="orange" value="1"></v-radio>
            <v-radio label="B、生产经营所得" color="orange" value="2"></v-radio>
            <v-radio label="C、利息、股息、转让证券等金融性资产收入" color="orange" value="3"></v-radio>
            <v-radio label="D、出租、出售房地产等非金下性资产收入" color="orange" value="4"></v-radio>
            <v-radio label="E、无固定收入" color="orange" value="5"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">3</span>
            <span class="title">您是否有尚未清偿的数额较大的债务，如有，其性质是：</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test3" :rules="testRules" column>
            <v-radio label="A、没有" color="orange" value="1"></v-radio>
            <v-radio label="B、有，住房抵押贷款等长期定额债务" color="orange" value="2"></v-radio>
            <v-radio label="C、有，信用卡欠款、消费信贷等短期信用债务" color="orange" value="3"></v-radio>
            <v-radio label="D、有，亲朋之间借款" color="orange" value="4"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">4</span>
            <span class="title">您的投资经验可以被概括为：</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test4" :rules="testRules" column>
            <v-radio label="A、有限：除银行活期帐户和定期存款外，我基本没有其他投资经验" color="orange" value="1"></v-radio>
            <v-radio label="B、一般：除银行活期帐户和定期存款外，我购买过基金、保险等理财产品，但还需要进一步的指导" color="orange" value="2"></v-radio>
            <v-radio label="C、丰富：我是一位有经验的投资者，参与过股票、基金等产品的交易，并倾向于自己做出投资决策" color="orange" value="3"></v-radio>
            <v-radio label="D、非常丰富：我是一位非常有经验的投资者，参与过政权、期货或创业板等高风险产品的交易" color="orange" value="4"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">5</span>
            <span class="title">当您选择了一项投资工具，相信它在未来的一段期间内将翻番，可是不久却下跌了20%，这时您将</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test5" :rules="testRules" column>
            <v-radio label="A、全部卖出" color="orange" value="1"></v-radio>
            <v-radio label="B、先卖出一部分" color="orange" value="2"></v-radio>
            <v-radio label="C、等待反弹，如果反弹超过10%，则追加投资" color="orange" value="3"></v-radio>
            <v-radio label="D、继续增加投资" color="orange" value="4"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">6</span>
            <span class="title">如果您有100万元进行投资，以下几种投资模式，您更偏好哪种模式？</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test6" :rules="testRules" column>
            <v-radio label="A、收益最多為5%，但不虧損" color="orange" value="1"></v-radio>
            <v-radio label="B、收益最多為30%，但可能虧損15%" color="orange" value="2"></v-radio>
            <v-radio label="C、收益最多為60%，但可能虧損30%" color="orange" value="3"></v-radio>
            <v-radio label="D、收益最多為100%，但可能虧損60%" color="orange" value="4"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">7</span>
            <span class="title">假设有两种不同的投资：投资A预期获得5%的收益，有可能承担非常小的损失；投资B预期获得20%的收益，但有可能面临25%甚至更高的亏损。您将您的投资资产分配为：</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test7" :rules="testRules" column>
            <v-radio label="A、全部投资于A" color="orange" value="1"></v-radio>
            <v-radio label="B、大部分投资于A" color="orange" value="2"></v-radio>
            <v-radio label="C、两种投资各一半" color="orange" value="3"></v-radio>
            <v-radio label="D、大部分投资于B" color="orange" value="4"></v-radio>
            <v-radio label="E、全部投资于B" color="orange" value="5"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">8</span>
            <span class="title">当您进行投资时，您的首要目标是：</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test8" :rules="testRules" column>
            <v-radio label="A、资产保值，我不愿意承担任何投资风险" color="orange" value="1"></v-radio>
            <v-radio label="B、尽可能保证本金安全，不在乎收益率比较低" color="orange" value="2"></v-radio>
            <v-radio label="C、产生较多的收益，可以承担一定的投资风险" color="orange" value="3"></v-radio>
            <v-radio label="D、实现资产大幅增长，愿意承担很大的投资风险" color="orange" value="4"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">9</span>
            <span class="title">您认为自己能承受的最大投资损失是多少?</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test9" :rules="testRules" column>
            <v-radio label="A、10%以内" color="orange" value="1"></v-radio>
            <v-radio label="B、10%(含) - 20%" color="orange" value="2"></v-radio>
            <v-radio label="C、20%(含) - 40%" color="orange" value="3"></v-radio>
            <v-radio label="D、40%(含) 以上" color="orange" value="4"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">10</span>
            <span class="title">以下哪一种类型描述了您现在的投资目的：</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test10" :rules="testRules" column>
            <v-radio label="A、注重短期的高投机回报，能承担短期很大的资产价值波动" color="orange" value="1"></v-radio>
            <v-radio label="B、关心长期的高回报，能够接受短期的资产价值波动" color="orange" value="2"></v-radio>
            <v-radio label="C、倾向于长期的成长，较少关心短期的回报和波动" color="orange" value="3"></v-radio>
            <v-radio label="D、希望在承担较小风险的情况下，获得波动适度的投资回报" color="orange" value="4"></v-radio>
            <v-radio label="E、希望在确保本金安全的情况下，获得固定的投资回报" color="orange" value="5"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">11</span>
            <span class="title">您的家庭负担状况：</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test11" :rules="testRules" column>
            <v-radio label="A、有充足的经济积累，可以应付所有的支出，没有负担" color="orange" value="1"></v-radio>
            <v-radio label="B、有一定的经济累积，但有其他方面较大的支出，总体而言，有一定的负担" color="orange" value="2"></v-radio>
            <v-radio label="C、没有经济积累或经济积累较少，但没有其他负担" color="orange" value="3"></v-radio>
            <v-radio label="D、没有经济积累或经济积累较少，且有其他方面较大的支出，负担较大" color="orange" value="4"></v-radio>
          </v-radio-group>

          <v-btn large color="warning" @click="savePersonTest()">送出</v-btn>
        </div>
      </v-form>
    </div>

    <div v-if="login_type === 'company'">
      <div class="desc">风险提示：私募基金投资需要承担各类风险，本金可能遭受损失。同时私募基金投资还需要考虑市场风险、信用风险、流动性风险。操作风险等各类投资风险。贵公司在基金认购过程中应当注意核对自己的风险识别和承受能力，选择与选择与自己风险识别能力和风险承受能力相匹配的私募基金。
        本问卷的评估结果可能不能完全准确的测试出贵公司面对投资风险的真正态度，但是可提供贵公司一些衡量自身风险承受能力的指标。本问卷的结果，将采取贵公司提供的信息的准确度和完整度。如果贵公司提供的信息不准确及/或不完整，或在所提供的信息发生变化后未及时更新，则可能对贵公司的投资风险承受能力评估结果以及向贵公司推荐适合贵公司风险承受能力的基金产品带来影响，如因此造成贵公司的投资损失，本公司将不承担任何责任。
      </div>

      <v-form ref="form2" v-model="valid">
        <div class="section1">
          <div class="main-title">（一）财务状况</div>
          <div class="question">
            <span class="num">1</span>
            <span class="title">贵公司目前的投资规模是</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test1" :rules="testRules" column>
            <v-radio label="A、大于5000万元" color="orange" value="1"></v-radio>
            <v-radio label="B、2000万到5000万元" color="orange" value="2"></v-radio>
            <v-radio label="C、1000万到2000万元" color="orange" value="3"></v-radio>
            <v-radio label="D、500万到1000万元" color="orange" value="4"></v-radio>
            <v-radio label="E、500万元以下" color="orange" value="5"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">2</span>
            <span class="title">根据贵公司目前以及将来预期的现金需求，可以将多少比例的投资收益用于再投资</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test2" :rules="testRules" column>
            <v-radio label="A、将所有投资收益用于再投资" color="orange" value="1"></v-radio>
            <v-radio label="B、50%以上的收益用于再投资" color="orange" value="2"></v-radio>
            <v-radio label="C、20%到50%的收益用于再投资" color="orange" value="3"></v-radio>
            <v-radio label="D、20%以下的收益用于再投资" color="orange" value="4"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">3</span>
            <span class="title">股公司的主要投资资金来源是</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test3" :rules="testRules" column>
            <v-radio label="A、其他大型机构投资者" color="orange" value="1"></v-radio>
            <v-radio label="B、其它小型机构投资者" color="orange" value="2"></v-radio>
            <v-radio label="C、个人投资者" color="orange" value="3"></v-radio>
            <v-radio label="D、自有资金" color="orange" value="4"></v-radio>
            <v-radio label="E、银行存款" color="orange" value="5"></v-radio>
          </v-radio-group>
        </div>

        <div class="section2">
          <div class="main-title">（二）投资经验</div>
          <div class="question">
            <span class="num">4</span>
            <span class="title">在本次投资之前，贵公司过往的投资经验</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test4" :rules="testRules" column>
            <v-radio label="A、仅包括银行存款" color="orange" value="1"></v-radio>
            <v-radio label="B、与银行存款类似、风险较低、结构简单的投资（余额宝或者类似余额宝的货币基金）" color="orange" value="2"></v-radio>
            <v-radio label="C、对股票、基金、金融衍生品等各投资品种与市场动态较为了解，并亲自打理投资" color="orange" value="3"></v-radio>
            <v-radio label="D、对投资产品较为了解，委托专业机构进行长线投资" color="orange" value="4"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">5</span>
            <span class="title">（非金融类且从未从事投资的公司填写）贵公司投资部门的设立情况是？</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test5" :rules="testRules" column>
            <v-radio label="A、机构未设专门的投资部门" color="orange" value="1"></v-radio>
            <v-radio label="B、投资部门已经设立，但运作不到1年" color="orange" value="2"></v-radio>
            <v-radio label="C、投资部门已经设立，且已运作1年以上" color="orange" value="3"></v-radio>
            <v-radio label="D、投资部门已经设立，且已运作3年以上" color="orange" value="4"></v-radio>
            <v-radio label="E、投资部门已经设立，且已运作5年以上" color="orange" value="5"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">6</span>
            <span class="title">（金融类或专门从事投资的公司填写）贵公司已成立并从事投资的时间</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test6" :rules="testRules" column>
            <v-radio label="A、1年以内" color="orange" value="1"></v-radio>
            <v-radio label="B、1-2年" color="orange" value="2"></v-radio>
            <v-radio label="C、2-5年" color="orange" value="3"></v-radio>
            <v-radio label="D、5年以上" color="orange" value="4"></v-radio>
          </v-radio-group>
        </div>

        <div class="section3">
          <div class="main-title">（三）投资目标</div>
          <div class="question">
            <span class="num">7</span>
            <span class="title">贵公司的投资目标是</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test7" :rules="testRules" column>
            <v-radio label="A、激进成长" color="orange" value="1"></v-radio>
            <v-radio label="B、显著增长" color="orange" value="2"></v-radio>
            <v-radio label="C、稳健增值" color="orange" value="3"></v-radio>
            <v-radio label="D、谨慎增值" color="orange" value="4"></v-radio>
            <v-radio label="E、避免亏损" color="orange" value="5"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">8</span>
            <span class="title">在正常的市场情况下，贵公司对这项投资的收益有何期望</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test8" :rules="testRules" column>
            <v-radio label="A、获得超越故股市表现的高收益，同时愿意承受比股市更大的波动" color="orange" value="1"></v-radio>
            <v-radio label="B、获得和股市相近的收益，同时愿意承受与股市相近的波动" color="orange" value="2"></v-radio>
            <v-radio label="C、逊于市场表现，但能取得适度盈利，同时波动较小" color="orange" value="3"></v-radio>
            <v-radio label="D、长期收益高于定期存款，同时波动比较小" color="orange" value="4"></v-radio>
            <v-radio label="E、收益高度稳定，但略有薄利" color="orange" value="5"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">9</span>
            <span class="title">贵公司计划的投资期限有多长</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test9" :rules="testRules" column>
            <v-radio label="A、10年以上" color="orange" value="1"></v-radio>
            <v-radio label="B、7-10年" color="orange" value="2"></v-radio>
            <v-radio label="C、4-6年" color="orange" value="3"></v-radio>
            <v-radio label="D、1-3年" color="orange" value="4"></v-radio>
            <v-radio label="E、1年以内" color="orange" value="5"></v-radio>
          </v-radio-group>
        </div>

        <div class="section4">
          <div class="main-title">（四）风险偏好及承受能力</div>
          <div class="question">
            <span class="num">10</span>
            <span class="title">下面哪一种描述最符合贵公司对今后三年投资表现的态度</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test10" :rules="testRules" column>
            <v-radio label="A、不介意亏损" color="orange" value="1"></v-radio>
            <v-radio label="B、能容忍亏损" color="orange" value="2"></v-radio>
            <v-radio label="C、能容忍少量亏损" color="orange" value="3"></v-radio>
            <v-radio label="D、难以容忍任何亏损" color="orange" value="4"></v-radio>
            <v-radio label="E、期期望至少能略有回报" color="orange" value="5"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">11</span>
            <span class="title">在未来五年内，贵公司预期主营业务收入会有何变化</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test11" :rules="testRules" column>
            <v-radio label="A、显著增长" color="orange" value="1"></v-radio>
            <v-radio label="B、有一定增长" color="orange" value="2"></v-radio>
            <v-radio label="C、保持不变" color="orange" value="3"></v-radio>
            <v-radio label="D、可能会有所下降" color="orange" value="4"></v-radio>
            <v-radio label="E、显著下降" color="orange" value="5"></v-radio>
          </v-radio-group>

          <div class="question">
            <span class="num">12</span>
            <span class="title">考虑到资本市场的起伏，下列哪一种可能得投资组合回报是贵公司最满意的</span>
          </div>
          <v-radio-group class="answer" v-model="temp.test12" :rules="testRules" column>
            <v-radio label="A、10年以上" color="orange" value="1"></v-radio>
            <v-radio label="B、7-10年" color="orange" value="2"></v-radio>
            <v-radio label="C、4-6年" color="orange" value="3"></v-radio>
            <v-radio label="D、1-3年" color="orange" value="4"></v-radio>
            <v-radio label="E、1年以内" color="orange" value="5"></v-radio>
          </v-radio-group>

          <v-btn color="warning" @click="saveCompanyTest()">送出</v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['reload'],
  props: {
    login_type: {
      type: String,
      default: 'person'
    },
    id: {
      type: Number
    }
  },
  data() {
    return {
      valid: false,
      temp: {
        id: this.id,
        test1: [],
        test2: '',
        test3: '',
        test4: '',
        test5: '',
        test6: '',
        test7: '',
        test8: '',
        test9: '',
        test10: '',
        test11: '',
        is_active: false
      },
      company_temp: {
        id: this.id,
        test1: [],
        test2: '',
        test3: '',
        test4: '',
        test5: '',
        test6: '',
        test7: '',
        test8: '',
        test9: '',
        test10: '',
        test11: '',
        test12: '',
        is_active: false
      },
      testRules: [v => !!v || '请填入答案'],
      rules: {
        atLeastOneSkill: selected => selected.length > 0 || '至少选一个选项'
      },
      test1_question: [
        'A、金融资产不低于300万元',
        'B、最近三年个人平均收入不低于50万元',
        'C、金融资产低于300万元',
        'D、最近三年个人年均收入低于50万元'
      ]
    }
  },
  methods: {
    savePersonTest() {
      if (this.$refs.form.validate()) {
        // 風險評測有沒有過
        if (this.temp.test1.indexOf('1') === -1 || this.temp.test1.indexOf('2') === -1) {
          this.temp.is_active = true
        } else {
          this.temp.is_active = false
        }
        this.$message.success('测评完成')

        this.temp.test1 = this.temp.test1.toString()

        this.$store.dispatch('updateUserData', this.temp).then(() => {
          this.$router.go(0)
        })
      }
    },
    saveCompanyTest() {
      if (this.$refs.form2.validate()) {
        if (this.temp.test1.indexOf('1') !== -1 || this.temp.test1.indexOf('2') !== -1) {
          this.temp.is_active = true
        } else {
          this.temp.is_active = false
        }

        this.$message.success('测评完成')

        this.$store.dispatch('updateUserData', this.temp).then(response => {
          this.$router.go(0)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.num {
  width: 36px;
  height: 36px;
  background-color: #f1f1f1;
  padding: 10px;
  text-align: center;
  line-height: 36px;
  margin-right: 26px;
}
#risk-test {
  margin: auto 50px;
  .main-title {
    font-size: 25px;
    font-weight: bold;
    margin: 25px auto;
  }

  .answer {
    margin-left: 55px;
  }
  .checkbox-answer {
    margin: 0 0 0 55px;
    padding: 0;
  }
  .desc {
    font-size: 16px;
    margin-right: 100px;
  }
}
</style>